import Vue from 'vue';
import * as Sentry from '@sentry/vue';
import { Integrations } from '@sentry/tracing';

Sentry.init({
    Vue,
    dsn: 'https://fa52e40d96494c3e95f745f7397f499a@o177029.ingest.sentry.io/5679252',
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 0.3,
    tracingOptions: {
        trackComponents: true,
    },
    logErrors: true,
    debug: process.env.NODE_ENV === 'development',
    attachStacktrace: true,
    sendDefaultPii: true,
    autoSessionTracking: true,
});
